export default __webpack_public_path__ + "static/comunity_img-1e4afe4ddfb5c3566519782187b943a9.png";